import { NgModule, ViewContainerRef } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DocumentLibraryComponent } from './document-library/document-library.component';
import { DocumentSliderComponent } from './document-slider/document-slider.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { BptTagsModule } from 'bpt-ui-library/bpt-tags';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { BptNumericInputModule } from 'bpt-ui-library/bpt-numeric-input';
import { BptFileUploadModule } from 'bpt-ui-library/bpt-file-upload'
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import { BadgeModule } from 'primeng/badge';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PanelModule } from 'primeng/panel';
import { DocumentGeneralDetailsComponent } from './document-slider/document-slider-menu/document-general-details/document-general-details.component';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { ChangeRequestModule } from '../change-request/change-request.module';
import { DocumentRequestEffectiveDateModalComponent } from './document-request-effective-date-modal/document-request-effective-date-modal.component';
import { DialogModule } from 'primeng/dialog';
import { DocumentLinkComponent } from './document-link/document-link.component';
import { HardCopyModule } from '../hard-copy/hard-copy.module';
import { NextPhaseComponent } from './phaseChange/next-phase/next-phase.component';
import { PreviousPhaseComponent } from './phaseChange/previous-phase/previous-phase.component';
import { DocumentReasonForChangeModalComponent } from './document-reason-for-change-modal/document-reason-for-change-modal.component';
import { SharedModule } from '../shared/shared.module';
import { ReviewStatusComponent } from './phaseChange/review-status/review-status.component';
import { ApprovalStatusComponent } from './phaseChange/approval-status/approval-status.component';
import { CancelButtonComponent } from './phaseChange/cancel-button/cancel-button.component';
import { UncancelButtonComponent } from './phaseChange/uncancel-button/uncancel-button.component';
import { DeactivateButtonComponent } from './phaseChange/deactivate-button/deactivate-button.component';
import { DocumentVersionDatesComponent } from './phaseChange/approval-status/DocumentApprovalAdditionalInformation/document-version-dates/document-version-dates.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DocumentVersionHistoryComponent } from './document-version-history/document-version-history.component';
import { DocumentFilesComponent } from './document-slider/document-slider-menu/document-files/document-files.component';
import { DocumentAttachmentsComponent } from './document-details/document-attachments/document-attachments.component';
import { EmailComponent } from './document-link/email/email.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import { DocumentAcknowledgementModule } from "../document-acknowledgement/document-acknowledgement.module";
import {DocumentSearchModule} from '../document-search/document-search.module';
import { DelegateSliderModule } from '../delegate-slider/delegate-slider.module';
import { DocumentCheckOutComponent } from './document-check-out/document-check-out.component';
import { AuditTrailModule } from "../audit-trail/audit-trail.module";
import { DocumentFileCheckinComponent } from './document-file-checkin/document-file-checkin.component';
import { DocumentProficiencyQuizSliderComponent } from './document-proficiency-quiz-slider/document-proficiency-quiz-slider.component';
import { QuizCreatorComponent } from '../shared-components/quiz-creator/quiz-creator.component';
import { DocumentTrainingComponent } from './document-training/document-training.component';
import { QuizCompletionComponent } from '../shared-components/quiz-completion/quiz-completion.component';
import { UpdateEffectiveDateButtonComponent } from './phaseChange/update-effective-date-button/update-effective-date-button.component';
import { DocumentRelatedDocumentsComponent } from './document-slider/document-slider-menu/document-related-documents/document-related-documents.component';
import { ChangeControlLibraryModule } from '../change-control/change-control-library/change-control-library.module';
import { RelatedDocumentsComponent } from '../shared-components/related-documents/related-documents.component';
import { DocumentCommentCreationSliderComponent } from './document-comment-creation-slider/document-comment-creation-slider.component';
import { DocumentCommentModalComponent } from './document-comment-modal/document-comment-modal.component';
import { DocumentBulkUserReplacementComponent } from './document-bulk-user-replacement/document-bulk-user-replacement.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { LabelComponent } from '../shared-components/label/label.component';
import { DocumentLoaderComponent } from './document-loader/document-loader.component';

@NgModule({
    declarations: [
        DocumentLibraryComponent,
        DocumentSliderComponent,
        DocumentGeneralDetailsComponent,
        DocumentDetailsComponent,
        NextPhaseComponent,
        DocumentRequestEffectiveDateModalComponent,
        DocumentLinkComponent,
        PreviousPhaseComponent,
        DocumentReasonForChangeModalComponent,
        ReviewStatusComponent,
        ApprovalStatusComponent,
        CancelButtonComponent,
        UncancelButtonComponent,
        DeactivateButtonComponent,
        DocumentVersionDatesComponent,
        DocumentVersionHistoryComponent,
        DocumentFilesComponent,
        DocumentAttachmentsComponent,
        EmailComponent,
        DocumentCheckOutComponent,
        DocumentFileCheckinComponent,
        DocumentProficiencyQuizSliderComponent,
        DocumentTrainingComponent,
        UpdateEffectiveDateButtonComponent,
        DocumentRelatedDocumentsComponent,
        DocumentCommentModalComponent,
        DocumentCommentCreationSliderComponent,
        DocumentBulkUserReplacementComponent,
        DocumentLoaderComponent
    ],
    providers: [ConfirmationService, MessageService, DatePipe],
    imports: [
        CommonModule,
        BrowserModule,
        BptTextInputModule,
        BptNumericInputModule,
        BptDateTimeModule,
        BptDropdownModule,
        BptTagsModule,
        TabViewModule,
        ButtonModule,
        TabMenuModule,
        FieldsetModule,
        DividerModule,
        BadgeModule,
        ScrollPanelModule,
        PanelModule,
        MessageModule,
        MessagesModule,
        DialogModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        ToastModule,
        CalendarModule,
        BptProgressSpinnerModule,
        ChangeRequestModule,
        HardCopyModule,
        SharedModule,
        CheckboxModule,
        BptSearchModule,
        BptFileUploadModule,
        SelectButtonModule,
        DocumentAcknowledgementModule,
        AuditTrailModule,
        DocumentSearchModule,
        DelegateSliderModule,
        QuizCreatorComponent ,
        QuizCompletionComponent,
        ChangeControlLibraryModule,
        RelatedDocumentsComponent,
        TreeSelectModule,
        EmptyResultsComponent,
        SpinnerComponent,
        LabelComponent
    ]
})
export class DocumentModule {}
